module.exports = __webpack_public_path__ + "img/88009030001858.a98e5dbe.png";